module.exports = __webpack_public_path__ + "img/selected5-min.ff1d291c.png";